<template>
  <transition name="fadePreloader">
    <div v-if="isOpen" class="aside" @mousedown.self="close">
      <transition name="mainAsideRightContainer">
        <div v-if="meta.showContainer" class="aside__container">
          <!-- deal-aside-scroll класс от которого добавляется скролл попапу соц сетей на адаптиве убирается из основного  -->
          <div
            :class="`aside__container-wrapper ${
              windowWidth < 1201 && scrollClass
            }`"
          >
            <slot />
          </div>
          <Icon
            v-if="!getSteps || getSteps == 1"
            class="aside__close"
            icon="aside-close"
            @click="close"
          />
          <Icon
            v-else
            class="aside__close"
            icon="arrow-back"
            @click="prevStep"
          />
        </div>
      </transition>
      <ClosePopup v-if="meta.showClosePopup" @popupResult="popupResult" />
    </div>
  </transition>
</template>

<script>
import ClosePopup from './ClosePopup';
export default {
  components: { ClosePopup },
  props: {
    isOpen: {
      type: Boolean,
      required: false
    },
    storePath: {},
    asideCanSave: {},
    forceCloseAside: {},
    scrollClass: {
      type: String,
      default: ''
    },
    ignorePopup: {
      type: Boolean,
      default: false
    },
    closePopupFunction: {},
    asideInAside: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    meta: {
      showContainer: false,
      showClosePopup: false
    }
  }),
  computed: {
    windowWidth() {
      return window.innerWidth;
    },
    forceClose() {
      if (!this.asideInAside) {
        if (this.storePath.includes('/')) {
          const path = this.storePath.split('/');
          if (path.length === 2) {
            return this.$store.state[path[0]][path[1]].aside.meta.forceClose;
          }
          if (path.length === 3) {
            return this.$store.state[path[0]][path[1]][path[2]].aside.meta
              .forceClose;
          }
        }
        return this.$store.state[this.storePath].aside.meta.forceClose;
      } else {
        if (this.storePath.includes('/')) {
          const path = this.storePath.split('/');
          if (path.length === 2) {
            return this.$store.state[path[0]][path[1]].aside.aside.meta
              .forceClose;
          }
          if (path.length === 3) {
            return this.$store.state[path[0]][path[1]][path[2]].aside.aside.meta
              .forceClose;
          }
        }
        return this.$store.state[this.storePath].aside.aside.meta.forceClose;
      }
    },
    getSteps() {
      return this.$store.state[this.storePath].aside.meta.step;
    }
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        setTimeout(() => {
          this.meta.showContainer = true;
        }, 0);
      }
    },
    forceClose() {
      if (!this.asideInAside) {
        if (this.forceClose) {
          this.$store.dispatch(`${this.storePath}/setAsideMeta`, {
            path: 'forceClose',
            value: false
          });

          this.finalAnimatedClose();
        }
      } else {
        if (this.forceClose) {
          this.$store.dispatch(`${this.storePath}/setAsideAsideMeta`, {
            path: 'forceClose',
            value: false
          });

          this.finalAnimatedClose();
        }
      }
    }
  },
  methods: {
    close() {
      if (!this.meta.showContainer) {
        return;
      }

      if (this.asideCanSave && !this.ignorePopup) {
        this.meta.showClosePopup = true;
        return;
      }

      this.finalAnimatedClose();
    },
    finalAnimatedClose() {
      this.meta.showContainer = false;
      setTimeout(() => {
        if (!this.asideInAside) {
          this.$store.dispatch(`${this.storePath}/setAsideMeta`, {
            path: 'isOpen',
            value: false
          });
        } else {
          this.$store.dispatch(`${this.storePath}/setAsideAsideMeta`, {
            path: 'isOpen',
            value: false
          });
        }
      }, 100);
    },
    popupResult(status) {
      this.meta.showClosePopup = false;

      if (status === 'close') {
        if (typeof this.closePopupFunction === 'function') {
          this.closePopupFunction();
        }

        this.finalAnimatedClose();
      }
    },
    prevStep() {
      this.$store.dispatch(`${this.storePath}/dicrementStep`);
      this.$store.dispatch(`${this.storePath}/setAsideData`, {
        path: 'canSave',
        value: false
      });
    }
  }
};
</script>
